function WarningIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      enableBackground="new 0 0 24 24"
      viewBox="0 0 24 24"
    >
      <g>
        <rect width="24" height="24" fill="none" />
      </g>
      <g>
        <g>
          <g>
            <path
              fill="currentColor"
              d="M15.73,3H8.27L3,8.27v7.46L8.27,21h7.46L21,15.73V8.27L15.73,3z M19,14.9L14.9,19H9.1L5,14.9V9.1L9.1,5h5.8L19,9.1V14.9z"
            />
            <rect width="2" height="6" x="11" y="7" fill="currentColor" />
            <rect width="2" height="2" x="11" y="15" fill="currentColor" />
          </g>
        </g>
      </g>
    </svg>
  );
}
export default WarningIcon;
